import React, { useEffect } from 'react';

export default function Drawer({ open, onClose, title, children, footer, width = 540 }) {
  useEffect(() => {
    const handler = e => { if (e.key === 'Escape') onClose(); };
    if (open) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  return (
    <>
      {open && <div role="presentation" onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.35)', zIndex: 50 }} />}
      <div style={{
        position: 'fixed', top: 0, right: open ? 0 : -width - 20,
        width, height: '100vh', background: '#fff',
        boxShadow: '-3px 0 18px rgba(0,0,0,.1)', zIndex: 51,
        transition: 'right .28s ease', display: 'flex', flexDirection: 'column'
      }}>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #e9ecef', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600, color: '#343a40' }}>{title}</h3>
          <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d', fontSize: 20, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 18 }}>{children}</div>
        {footer && <div style={{ padding: '12px 18px', borderTop: '1px solid #e9ecef', display: 'flex', justifyContent: 'flex-end', gap: 8, flexShrink: 0 }}>{footer}</div>}
      </div>
    </>
  );
}
